function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#city_care_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.925.35l8.15 4.74c.86.468 1.258 1.269 1.258 2.203v9.413c0 1.002-.397 1.736-1.258 2.204l-8.083 4.74c-.73.467-1.723.467-2.584 0l-8.15-4.674C.53 18.51 0 17.708 0 16.773v-9.48c0-1 .464-1.735 1.259-2.203L9.342.35c.86-.467 1.855-.467 2.583 0z",
  fill: "#1976D2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.566 17.649a1.31 1.31 0 01-1.793-.007l-.073-.068c-3.498-3.23-5.784-5.345-5.698-7.983.04-1.156.62-2.265 1.56-2.917 1.76-1.224 3.932-.653 5.104.748 1.173-1.401 3.346-1.98 5.105-.748.94.652 1.52 1.76 1.56 2.917.093 2.638-2.2 4.753-5.698 7.997l-.067.06z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "city_care_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h21.333v24H0z"
})));

function SvgCityCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCityCare;